import BUILD_VERSION from '/src/utils/version';


const NODE_ENV = process.env.NODE_ENV

const ROOT_API = import.meta.env.VITE_API_URL


let SIM_FRONT_ENV = {
    BUILD_VERSION,
    NODE_ENV,
    ROOT_API,
}

export default SIM_FRONT_ENV
